const frqtaRouter = {
  list: {
    path: '/factoryInquiryForm_list',
    name: 'FactoryInquiryFormList',
    component: () => import('@/views/DevelopManagement/FRqtaManage/RqtaList.vue'),
    meta: {
      title: '工厂询价单'
    }
  },
  edit: {
    path: '/factoryInquiryForm_edit',
    name: 'FactoryInquiryFormEdit',
    component: () => import('@/views/DevelopManagement/FRqtaManage/RqtaEdit.vue'),
    meta: {
      title: '工厂询价单 (编辑)'
    }
  }
};
export default frqtaRouter;
